import { StudentSectionSettingTypeCodes } from 'const';
import { sportWidgetVisibilityHooks } from 'hooks';
import {
  sportClubsSelector,
  sportCompetitionsSelector,
  sportExpeditionsSelector,
  sportOccupationsSelector,
  sportRewardsSelector,
} from 'selectors';
import { getDataLoadRequests } from 'utils';

import { SectionLoaderConfig } from './types';

export const getSportLoaderConfig = (): SectionLoaderConfig => {
  return [
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.sportReward,
      requests: getDataLoadRequests().sportRewards,
      loadingSelector: sportRewardsSelector,
      dataSelector: (state) => sportRewardsSelector(state).content.length > 0,
      useWidgetVisibility: sportWidgetVisibilityHooks.useRewards,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.sportClub,
      requests: getDataLoadRequests().sportClubs,
      loadingSelector: sportClubsSelector,
      dataSelector: (state) => sportClubsSelector(state).content.length > 0,
      useWidgetVisibility: sportWidgetVisibilityHooks.useClubs,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.sportUnit,
      requests: getDataLoadRequests().sportSections,
      loadingSelector: sportOccupationsSelector,
      dataSelector: (state) => sportOccupationsSelector(state).content.length > 0,
      useWidgetVisibility: sportWidgetVisibilityHooks.useSections,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.sportGame,
      requests: getDataLoadRequests().sportCompetitions,
      loadingSelector: sportCompetitionsSelector,
      dataSelector: (state) => sportCompetitionsSelector(state).content.length > 0,
      useWidgetVisibility: sportWidgetVisibilityHooks.useCompetitions,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.sportHike,
      requests: getDataLoadRequests().sportExpeditions,
      loadingSelector: sportExpeditionsSelector,
      dataSelector: (state) => sportExpeditionsSelector(state).content.length > 0,
      useWidgetVisibility: sportWidgetVisibilityHooks.useExpeditions,
    },
  ];
};
